import Automovel from './automovel';

export default Automovel;